import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { CampoEstatico, TipoCampoEstatico } from '@intechprev/componentes-web';
import { FichaContribPrevidencialService } from '../../../services';

interface QuotasProps {
  quotas: any[];
}

const Quotas: React.FC<QuotasProps> = ({ quotas }) => {

  return (
    <table className={"table table-striped table-sm"}>
      <thead>
        <tr>
          <th></th>
          <th className={"text-right"}>Valor Quota</th>
        </tr>
      </thead>
      <tbody>
        {quotas && quotas.map((quota: any, index: number) => {
          // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
          var Td = (props: any) => <td className={props.className}>{props.children}</td>;

          if (index == quotas.length - 1)
            Td = (props: any) => <th className={props.className}>{props.children}</th>;

          return (
            <tr key={index}>
              <Td>{quota.Key}</Td>
              <Td className={"text-right"}>
                <CampoEstatico valor={quota.Value} tipo={TipoCampoEstatico.texto} />
              </Td>
            </tr>
          )
        })}
      </tbody>
    </table>
  );
}

export default Quotas;